module.exports = __webpack_public_path__ + "static/event-flyer-3fa6b05e718049a4619237469a9a3435.jpeg";